<div #elRef class="bar"></div>
